import Context from './context.js';

export default class Sort{
    start(){
        const items = document.querySelectorAll( '._js_sort_item' );
        items.forEach(
            item => {
                item.addEventListener(
                    'click' ,
                    ( el ) => {

                        let context = Context.get( 'sort' ) ?? {};
                        let context_type = context?.type ?? '';
                        let context_state = context?.state ?? '';

                        let field = item.dataset.type ?? '';
                        let state = item.dataset.sort ?? '';

                        if( !field ){
                            return;
                        }

                        if( !state ){
                            state = context_type !== field || context_state === 'desc' ? 'asc' : 'desc';
                        }

                        Context.set( 'sort' , { field : field , state : state } );

                        items.forEach(
                            i => {

                                i.classList.remove( 'asc' , 'desc' , 'active' );
                                let ifield = i.dataset.field ?? '';
                                let istate = i.dataset.sort ?? '';

                                if( ifield !== field || !ifield || !field ){
                                    return;
                                }

                                if( istate ){
                                    if( istate === state ){
                                        i.classList.add( 'active' );
                                    }
                                }else{
                                    i.classList.add( state );
                                }
                            }
                        )

                    }
                );

            }
        );
    }
}
